import { Component, ElementRef, Input, Renderer2, ViewChild } from '@angular/core';

import { OpenLRLocationReferencePoint } from 'app/models/openlr';
import { CbmInputStyle } from 'app/shared/input/cbm-input-style';

@Component({
  selector: 'linear-openlr',
  templateUrl: './linear-openlr.component.html',
  styleUrls: ['./linear-openlr.component.scss']
})
export class LinearOpenlrComponent {
  @Input() id: string;
  @Input() label: string;
  @Input() inputStyle: CbmInputStyle;
  @Input() locationReferencePoint: OpenLRLocationReferencePoint;
  @Input() open = false;

  @ViewChild('body') body: ElementRef;

  constructor(private readonly renderer: Renderer2) {}

  public collapse(open?: boolean): void {
    if (open == null) {
      if (this.body.nativeElement.classList.contains('in')) {
        this.closeItem();
      } else {
        this.openItem();
      }
    } else if (open) {
      this.openItem();
    } else {
      this.closeItem();
    }
  }

  private openItem(): void {
    this.renderer.addClass(this.body.nativeElement, 'in');
  }

  private closeItem(): void {
    this.renderer.removeClass(this.body.nativeElement, 'in');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/openlr/linear/linear-openlr.component.ts